import {useGetAllWellsQuery, WellEntity, WellSelectorProps, wellsSelector} from "@ots-frontend/ots-data";
import {BaseWellMultiSelect, BaseWellMultiSelectProps} from "./BaseWellMultiSelect";
import {useMemo, useState} from "react";
import {Box, Button, Modal, ModalProps} from "@mantine/core";
import {useTranslation} from "react-i18next";

export type WellMultiSelectProps = Omit<BaseWellMultiSelectProps, "entities" | "loading"> & {
  selector?: WellSelectorProps
}

export const WellMultiSelect = (props: WellMultiSelectProps) => {
  const {
    selector,
    ...rest
  } = props;

  const selectWells = useMemo(() => {
    return wellsSelector()
  }, []);

  const {wells, isLoading} = useGetAllWellsQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      wells: selectWells(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseWellMultiSelect entities={wells} loading={isLoading} {...rest} />;
};

export interface WellMultiSelectModalProps extends Omit<ModalProps, "onSubmit"> {
  select?: WellMultiSelectProps,
  onSubmit?: (wells: WellEntity[] | undefined) => void
}

export const WellMultiSelectModal = (props: WellMultiSelectModalProps) => {
  const {
    select,
    onSubmit,
    ...rest
  } = props;

  const [selectedWells, setSelectedWells] = useState<WellEntity[]>([])

  const {t} = useTranslation(["common"]);

  return (
    <Modal {...rest}>
      <Box>
        <WellMultiSelect
          {...select}
          onEntityChange={e => setSelectedWells(e)}/>
        <Button type="submit" mt="xl" onClick={(e) => {
          if (onSubmit) {
            onSubmit(selectedWells);
          }
        }}>
          {t("common.action.submit")}
        </Button>
      </Box>
    </Modal>
  );
};
